/**
 * object-fit Polyfill
 * http://codepen.io/jonneal/pen/EKPONK
 */
if ('objectFit' in document.documentElement.style === false) {
    document.addEventListener('DOMContentLoaded', function () {
        Array.prototype.forEach.call(document.querySelectorAll('img[data-object-fit]'), function (image) {
            (image.runtimeStyle || image.style).background = 'url("' + image.src + '") no-repeat 50%/' + (image.currentStyle ? image.currentStyle['object-fit'] : image.getAttribute('data-object-fit'));
            image.src = 'data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'' + image.width + '\' height=\'' + image.height + '\'%3E%3C/svg%3E';
        });
    });
}

$(function(){
    $("button.burger").click(function(){
        $("header").toggleClass("navopen");
    });

    if($("#coverCarousel").length) {
        $("#coverCarousel .carousel").slick({
            dots: false,
            arrows: false,
            autoplay: true,
            fade: true,
            speed: 750,
            autoplaySpeed: 5000,
            lazyLoad: 'progressive',
            cssEase: 'linear',
            pauseOnHover: false,
            pauseOnFocus: false
        });
    }

    if($(".thingsToDo .carousel").length) {
        $(".thingsToDo .carousel").slick({
            dots: true,
            arrows: false,
            fade: false,
            speed: 750,
            autoplay: true,
            autoplaySpeed: 5000,
            lazyLoad: 'progressive',
            cssEase: 'linear',
            pauseOnHover: false,
            pauseOnFocus: false
        });
    }

    // Smooth Scrolling
    $('a[href*="#"]:not([href="#"])').click(function() {
        var that = $(this);
        if (location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') && location.hostname === this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
            if (target.length) {
                var offset = 0;
                if(that.data('scroll-offset') !== undefined) {
                     offset = that.data('scroll-offset');
                }

                $('html, body').animate({
                    scrollTop: target.offset().top - offset
                }, 1000);

                return false;
            }
        }
    });

    if($("body#top-5-things").length) {
        $("#search").autocomplete({
            source: tags,
            open: function() {
                $(this).addClass("search-open");
            },
            close: function() {
                $(this).removeClass("search-open");
            },
            select: function(event, ui) {
                var that = $(this);
                that.val(ui.item.value);

                $.ajax({
                    url: "/top-5-things/ajaxsearch?s="+$(this).val(),
                    cache: false,
                    beforeSend: function(){
                        that.blur();
                        $("ul.tilegrid").fadeTo(100,0.5);
                    },
                    error: function() {
                        $("ul.tilegrid").fadeTo(100,1);
                    },
                    success: function(data){
                        $(".results-wrap").html(data);
                        $("ul.tilegrid").fadeTo(100,1);
                    }
                });
            }
        });
    }


    $(window).on("scroll", window, function(){
        $("[data-animate]:not(.animate)").each(function(){
            var trigger_percentage = 66;
            if(!isNaN(parseInt($(this).data("animate")))) {
                trigger_percentage = parseInt($(this).data("animate"));
            }

            var viewport_position_px = ($(window).height() - $(window).scrollTop());
            var viewport_position_percent = viewport_position_px / $(window).height() * 100;

            if(trigger_percentage >= viewport_position_percent) {
                $(this).addClass("animate");
            }
        });
    });

    $(".imageHeader.parallax").each(function(){
        $(this).css("backgroundImage", "url("+$(this).data("image-src")+")");
    });

    /*
    $(window).on("scroll", window, function(){
        $(".imageHeader.parallax").each(function(){
            var bcr = this.getBoundingClientRect();
            var bump = 50 + ((bcr.top - $(window).scrollTop()) * 0.1);

            if(bump >= 0 && bump <= 100) {
                $(this).css("backgroundPositionY", bump + "%");
            }
        });
    });
    */

    if($("body#perks").length) {
        $(window).on("scroll", window, function(){
            if($(this).scrollTop() > 16) {
                $("body").addClass("perksLede-fixed");
            } else {
                $("body").removeClass("perksLede-fixed");
            }
        }).scroll();
    }

    // if($("body#feedback").length) {
    //     $("ul.tilegrid.feedback li").click(function(){
    //         alert('hi!');
    //     });
    // }
});